import { render, staticRenderFns } from "./CharacterAvatarChoose.vue?vue&type=template&id=3f0cbc36&scoped=true"
import script from "./CharacterAvatarChoose.vue?vue&type=script&lang=js"
export * from "./CharacterAvatarChoose.vue?vue&type=script&lang=js"
import style0 from "./CharacterAvatarChoose.vue?vue&type=style&index=0&id=3f0cbc36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0cbc36",
  null
  
)

export default component.exports